import { render, staticRenderFns } from "./AddRulesChooseMembersDialog.vue?vue&type=template&id=0099da80&scoped=true"
import script from "./AddRulesChooseMembersDialog.vue?vue&type=script&lang=ts"
export * from "./AddRulesChooseMembersDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddRulesChooseMembersDialog.vue?vue&type=style&index=0&id=0099da80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0099da80",
  null
  
)

export default component.exports